const mutations = {
  SAVE_APPLICATION_SUMMARY(state, data) {
    if (data.referralCallbackUrl) {
      localStorage.setItem('referralCallbackUrl', data.referralCallbackUrl);
    }
    if (data.referralMarketplaceMcode) {
      localStorage.setItem('referralMarketplaceMcode', data.referralMarketplaceMcode);
    }
    state.applicationSummary = data;
  },
  SET_LATEST_LOAN_ID(state, data) {
    localStorage.setItem('latestLoanId', data);
    state.latestLoanId = data;
  },
  SAVE_LANGUAGE(state, data) {
    state.legalLanguage = data;
    localStorage.setItem('legalLanguage', JSON.stringify(data));
  },
  SAVE_NBFC_NAME(state, data) {
    state.nbfcName = data;
    localStorage.setItem('nbfcName', JSON.stringify(data));
  },
  SET_SUPPORT_ID(state, data) {
    localStorage.setItem('supportId', data);
    state.supportId = data;
  },
  SET_WELCOME_REWARDS_DATA(state, data) {
    state.welcomeRewardsData = data;
  },
  SET_IS_BUSINESS_REGISTRATION_DOC_UPLOADED(state, data) {
    state.isBusinessRegistrationDocUploaded = data;
  },
  SET_IS_BANK_STATEMENT_DOC_UPLOADED(state, data) {
    state.isBankStatementDocUploaded = data;
  },
  APPLICATION_PROFILE_DATA(state, data) {
    state.applicationProfileData = data;
  }

};
export default mutations;
